import {
  SPOR_TOTO_COUPON_DETAIL_REQUEST,
  SPOR_TOTO_COUPON_DETAIL_SUCCESS,
  SPOR_TOTO_COUPON_DETAIL_FAILURE
} from 'Store/constants';

const initialState = {
  data: {},
  isLoading: null,
  error: null
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SPOR_TOTO_COUPON_DETAIL_REQUEST:
      return { ...state, data: {}, isLoading: true, error: null };
    case SPOR_TOTO_COUPON_DETAIL_SUCCESS:
      return { ...state, data: action.payload, isLoading: false, error: false };
    case SPOR_TOTO_COUPON_DETAIL_FAILURE:
      return { ...state, data: {}, isLoading: false, error: action.payload };
    default:
      return state;
  }
};
